// extracted by mini-css-extract-plugin
export default {"dateRow":"XVID9Usm9p"};